import * as routesUtils from '../utils/RoutesUtils'
import { API } from '../core/app.routes'
import httpClient from '../core/httpClient'
import commonService from './common.service'

const pdfService = () => {
  const common = commonService()
	return {
    downloadPDF: async (params = {}) => {
			const path = routesUtils.getApiPath(API.PDF_INVOICE, params)
			return httpClient.get(path)
				.then((res) => {
          console.log('res', res)
          common.downloadLink(`invoice_${params.invoiceId}.pdf`, res.url)
          return res
					// return common.jobPolling(job, 10).then(({ job }) => {
					// 	const { data } = job
					// 	
					// })
				})
		},
	}
}

export default pdfService
